import { ROUTES } from '@/constants/route.constant';
import CustomImage from './Image';
import { Link } from './Link';
import Logo from '@/assets/logos/logo.svg';

type WebsiteLogoProps = {
  height?: number;
  width?: number;
  className?: string;
};

const WebsiteLogo = ({
  height = 30,
  width = 113,
  className,
}: WebsiteLogoProps) => {
  return (
    <Link href={ROUTES.DASHBOARD.TIMESHEET}>
      <CustomImage
        src={Logo}
        alt='Logo'
        width={width}
        height={height}
        className={className}
      />
    </Link>
  );
};

export default WebsiteLogo;
